import { store } from '../store'
const { DateTime } = require('luxon')

function setZonedTimeFromIso (date) {
  const localDate = DateTime.fromISO(date)
  let timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
  if (store.getters.timezone) {
    timeZone = store.getters.timezone
  }
  const zonedTime = localDate.setZone(timeZone)
  return zonedTime.toFormat("hh':'mm a")
}

function setZonedTimeFromUTCISO (date) {
  const utcDate = DateTime.fromISO(date, {zone: 'utc'})
  let timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
  if (store.getters.timezone) {
    timeZone = store.getters.timezone
  }
  const zonedTime = utcDate.setZone(timeZone)
  return zonedTime.toISO()
}

function getFormatDateFromISO (date, config) {
  const parsedDate = DateTime.fromISO(date, {zone: store.getters.timezone ? store.getters.timezone : Intl.DateTimeFormat().resolvedOptions().timeZone})
  return parsedDate.toFormat(config)
}

export {
  setZonedTimeFromIso,
  setZonedTimeFromUTCISO,
  getFormatDateFromISO
}



// WEBPACK FOOTER //
// ./src/lib/time-transformations.js